import { Injectable, ElementRef } from '@angular/core';
import { Node, Link, ForceDirectedGraph } from './models';
import * as d3 from 'd3';

@Injectable()
export class D3Service {
    private stepCounter = 0;
    /** This service will provide methods to enable user interaction with elements
     * while maintaining the d3 simulations physics
     */
    // constructor() {}
    container!: d3.Selection<any, unknown, null, undefined>;

    /** A method to bind a pan and zoom behaviour to an svg element */
    applyZoomableBehaviour(svgElement: ElementRef<any>, containerElement: any) {
        // let zoomed, zoom;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const svg = d3.select(svgElement);
        this.container = d3.select(containerElement);

        const zoomed = () => {
            const transform = d3.event.transform;
            this.container.attr('transform', 'translate(' + transform.x + ',' + transform.y + ') scale(' + transform.k + ')');
        };

        const zoom = d3.zoom().on('zoom', zoomed);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        // minimize initial zoom
        svg.call(zoom).call(zoom.transform, d3.zoomIdentity.translate(0, 0).scale(0.7));
        // svg.call(zoom).call(zoom.transform, d3.zoomIdentity.translate(-4192.754627701032, 763.69982792330427).scale(0.44639348362142));
        //translate(-4192.229640335515,763.2392622893605) scale(0.4437831595859312)
        svg.call(zoom as any).on('dblclick.zoom', null);
    }

    /** A method to bind a draggable behaviour to an svg element */
    applyDraggableBehaviour(element: any, node: Node, graph: ForceDirectedGraph) {
        const d3element = d3.select(element);

        function started() {
            /** Preventing propagation of dragstart to parent elements */
            d3.event.sourceEvent.stopPropagation();

            if (!d3.event.active) {
                graph.simulation.alphaDecay(0.1).restart();
            }

            function ended() {
                if (!d3.event.active) {
                    graph.simulation.alphaTarget(0.3);
                }

                /** uncomment if want nodes to be relocated at their orginal positions after dragging  */
                // node.fx = null;
                // node.fy = null;

                node.fx = d3.event.x;
                node.fy = d3.event.y;
            }

            function dragged() {
                node.fx = d3.event.x;
                node.fy = d3.event.y;
                //todo
                // fix_nodes(node);
            }

            // todo
            //  // Preventing other nodes from moving while dragging one node
            // function fix_nodes(this_node) {
            //     this.nodes.each(function (d) {
            //         if (this_node != d) {
            //             d.fx = d.x;
            //             d.fy = d.y;
            //         }
            //     });
            // }

            d3.event.on('drag', dragged).on('end', ended);
        }

        d3element.call(d3.drag().on('start', started));
        const stepId = 'step-' + this.stepCounter++ + '-graph'; // Set step ID
        d3element.attr('id', stepId).call(d3.drag().on('start', started));
    }

    resetStepCounter() {
        this.stepCounter = 0; // Reset step counter to 0
    }

    /** A method to bind a pan and zoom behaviour to an svg element */
    applyHoverableBehaviour(element: any, node: Node, graph: ForceDirectedGraph) {
        const d3element = d3.select(element);

        function entered(e: any) {
            console.log('element', d3element);
            console.log('----------------------------------------');
            console.log('node', node);
            console.log('----------------------------------------');
            console.log('graph', graph);
            console.log('----------------------------------------');

            const nodeCount = d3.select('svg').selectAll('text').nodes().length;
            console.log('----------------------------------------', nodeCount);
            const allnodesonpage = d3.select('svg').selectAll('text').nodes();
            console.log('----------------------------------------', allnodesonpage);

            // if (nodeCount > 0) {
            //     const separation = 12;
            //     const maxLength = 25;
            //     const textX = 0;
            //  d3.select('svg')
            //      .selectAll('circle')
            //      .nodes()
            //      .forEach((d) => {
            //         d3.select(d).selectAll
            //             if (d3.select(d).text().replace('\n', '').trim() != '') {
            //                 const lines = this.wordwrap2(d3.select(d).text().replace('\n', '').trim(), maxLength, '\n', false).split('\n');
            //                 d3.select(d).html('');
            //                 for (let i = 0; i < lines.length; i++) {
            //                     d3.select(d).append('tspan').attr('dy', separation).attr('x', textX).text(lines[i]);
            //                     d3.select(d).attr('transform', 'translate(0,' + ((separation * lines.length) / 2) * -1 + ')');
            //                 }
            //             }
            //         });
            // }

            // var el = d3.select("#svg");
            // el.selectAll("g")
            // console.log(el);

            //  console.log(e);
            //   console.log(graph.links);
            //   console.log(graph.nodes);
            //   console.log(node.id);
            // d3.select('svg')
            //     .selectAll('line')
            //     .nodes()
            //     .forEach((d) => {
            //         console.log(d);
            //    })
            // node.fontSize="20px";
            // console.log(d3.select("nodes").selectAll('circle'))

            // let currentSize = d3.select(this).attr('r');
            // console.log('------', currentSize);
            // d3.select(this).attr('r', currentSize + 100);

            // console.log('circle --------- ', d3.select('svg').selectAll('circle'));

            // d3.select('svg')
            // .selectAll('circle').style("opacity", function(o) {
            //     return graph.links.source === d || o.target === d ? 1 : opacity;
            //   });

            const allNods = graph.nodes;

            const connectedNodeIdsf = graph.links.filter((x) => x.source.id === node.id || x.target.id === node.id);
            console.log('new---------------', connectedNodeIdsf);

            const connectedNodeIds = graph.links
                .filter((x) => x.source.id === node.id || x.target.id === node.id)
                .map((x) => (x.source.id === node.id ? x.target.id : x.source.id));
            // console.log('node selected -  ', node);
            console.log('node filtered -  ', connectedNodeIds);

            console.log('-------allNods', allNods);

            const allNodeIds = allNods
                .filter((x) => {
                    return true; // Keep all nodes in the resulting array
                })
                .map((x) => {
                    return x.id; // Map each node to its ID
                });

            console.log('allids', allNodeIds);
            // allNods.map((x) =>
            d3.select('svg')
                .selectAll('circle')
                .attr('stroke-width', function () {
                    if (allNodeIds.some((r) => connectedNodeIds.indexOf(r) >= 0) || allNodeIds.indexOf(node.id) > -1) {
                        //if (connectedNodeIds.indexOf(x.id) > -1 || x.id == node.id) {
                        return 4;
                    } else {
                        console.log('*************');
                        return 10;
                    }
                })
                .attr('stroke', function () {
                    //   console.log('++++++++', x.id);
                    //if (connectedNodeIds.indexOf(x.id) > -1 || x.id === node.id) {
                    if (allNodeIds.some((r) => connectedNodeIds.indexOf(r) >= 0) || allNodeIds.indexOf(node.id) > -1) {
                        return 'grey';
                    } else return 'black';
                });
            // );
            graph.simulation.alphaDecay(0.1).restart();
        }

        function exited() {
            // alert()
            d3.select('svg')
                .selectAll('circle')
                .attr('stroke-width', function (c) {
                    return 0;
                });
            graph.simulation.alphaDecay(0.1).restart();
        }

        //  d3element.on('mouseover', entered);
        // d3element.on('mouseout', exited);
    }

    /** The interactable graph we will simulate
     * This method does not interact with the document, purely physical calculations with d3
     */
    getForceDirectedGraph(nodes: Array<Node>, links: Array<Link>, options: { width: any; height: any }) {
        return new ForceDirectedGraph(nodes, links, options);
        // return sg;
    }
}
